import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { PublicProfileActionType, PublicProfileStore } from './PublicProfile.types';

// @ts-ignore
export const initialState: PublicProfileStore = Immutable.fromJS({
  profile: {},
  isFetching: false,
});

const PublicProfileReducer = handleActions<any>(
  {
    PROFILE_REQUEST: (state: PublicProfileStore) => state.set('isFetching', true),

    PROFILE_RESPONSE_FAILURE: (state: PublicProfileStore) => state.set('isFetching', false),
    PROFILE_RESPONSE: (state: PublicProfileStore, action: PublicProfileActionType) => {
      return state.set('isFetching', false).set('profile', Immutable.fromJS(action.payload.data));
    },
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);

export default PublicProfileReducer;
